// extracted by mini-css-extract-plugin
export default {"normRow":"ReportSummary_normRow__pjGjj"};